export const LogType = {
  DAMAGE: "damage",
  CRIT: "crit",
  HEAL: "heal",
  STATUS: "status",
  DEATH: "death",
  DROP: "drop",
  INFO: "info",
  BLOCKED: "blocked",
};

export const SegmentType = {
  TEXT: "text",
  CREATURE: "creature",
  WEAPON: "weapon",
  DAMAGE: "damage",
  HEAL: "heal",
  CRIT: "crit",
  LIFESTEAL: "lifesteal",
  STATUS: "status",
};

function text(value) {
  return { type: SegmentType.TEXT, value };
}

function creature(c) {
  return { type: SegmentType.CREATURE, value: c.name, details: { hp: c.health, maxHp: c.maxHealth, armor: c.armor } };
}

function weapon(w) {
  return { type: SegmentType.WEAPON, value: w.name, weapon: w };
}

function dmg(amount, details) {
  return { type: SegmentType.DAMAGE, value: formatNum(amount), details };
}

function heal(amount, details) {
  return { type: SegmentType.HEAL, value: formatNum(amount), details };
}

function crit(multiplier) {
  return { type: SegmentType.CRIT, value: "CRIT", details: { multiplier } };
}

function lifesteal(amount, details) {
  return { type: SegmentType.LIFESTEAL, value: formatNum(amount), details };
}

function status(name, stacks) {
  return { type: SegmentType.STATUS, value: name, details: { stacks } };
}

export function createLog(type, segments) {
  return { type, segments, timestamp: Date.now() };
}

export function damageLog(attacker, defender, damage, details) {
  return createLog(LogType.DAMAGE, [
    creature(attacker),
    text(" dealt "),
    dmg(damage, details),
    text(" damage to "),
    creature(defender),
  ]);
}

export function blockedLog(attacker, defender, details) {
  return createLog(LogType.BLOCKED, [
    creature(defender),
    text(" blocked "),
    creature(attacker),
    text("'s attack (" + details.baseDamage + " vs " + details.armor + " armor)"),
  ]);
}

export function critLog(attacker, defender, damage, details) {
  return createLog(LogType.CRIT, [
    creature(attacker),
    text(" "),
    crit(details.critMultiplier),
    text(" "),
    dmg(damage, details),
    text(" damage to "),
    creature(defender),
  ]);
}

export function healLog(target, amount, details) {
  return createLog(LogType.HEAL, [
    creature(target),
    text(" healed "),
    lifesteal(amount, details),
  ]);
}

export function statusLog(target, effectName, stacks, isNew) {
  const action = isNew ? " afflicted with " : " gained ";
  return createLog(LogType.STATUS, [
    creature(target),
    text(action),
    status(effectName, stacks),
  ]);
}

export function statusDamageLog(target, damage, effect) {
  const details = {
    stackDamage: effect.stackDamage,
    stacks: effect.stacks,
    weaponDamage: effect.stats?.weaponDamage,
    baseMultiplier: effect.stats?.baseMultiplier,
    rollMultiplier: effect.stats?.rollMultiplier,
  };
  return createLog(LogType.STATUS, [
    creature(target),
    text(" took "),
    dmg(damage, details),
    text(` ${effect.type} damage`),
  ]);
}

export function deathLog(creature) {
  return createLog(LogType.DEATH, [
    { type: SegmentType.TEXT, value: creature.name },
    text(" died"),
  ]);
}

export function infoLog(message) {
  return createLog(LogType.INFO, [text(message)]);
}

export function dropLog(item) {
  if (typeof item === "string") {
    return createLog(LogType.DROP, [text(`Dropped: ${item}`)]);
  }
  return createLog(LogType.DROP, [
    weapon(item),
    text(" was dropped."),
  ]);
}

function formatNum(num) {
  if (num === null || num === undefined) return "?";
  return Number.isInteger(num) ? num : parseFloat(num.toFixed(2));
}
